export enum ContributionRuleValueUpdateType {
CoveragePackage,
Fixed,
Parameter,
Expression,
}
